<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="`${item.name}（${item.code}）`"
      :value="item.id"
    >
      <span style="float: left">{{ item.name }}（{{ item.code }}）</span>
      <el-tag
        size="mini"
        effect="dark"
        v-if="!singleSelect"
        style="float: right; font-size: 12px; background: #409eff"
        >装配</el-tag
      >
    </el-option>
  </el-select>
</template>

<script>
import { itemList } from '../../service/getData'

export default {
  props: {
    val: '',
    value: '',
    category: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
    templateid: {
      type: Number,
      default: 0,
    },
    filterids: {
      type: Array,
      default: () => [],
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
    install: {
      type: Boolean,
      default: false,
    },
    transfer: {
      type: Boolean,
      default: false,
    },
    baseid: {
      type: Number,
      default: 0,
    },
    wellid: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      }
    },
  },
  computed: {
    options() {
      return this.lists.filter((item) => !this.filterids.includes(item.id))
    },
  },
  data() {
    return {
      selected: '',
      lists: [],
      loading: false,
    }
  },
  async created() {
    if (this.value) {
      await this.requestData('default')
      this.selected = this.value
      this.$emit('info', this.lists.filter((item) => item.id == this.value)[0])
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', parseInt(this.selected) || 0)
      this.$emit(
        'info',
        this.selected
          ? this.lists.filter((item) => item.id == this.selected)[0]
          : null,
      )

      if (!this.singleSelect) {
        this.selected = ''
      }
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          code: query == 'default' ? '' : query,
          category: this.category,
          item_template_id: this.templateid,
          install: this.install,
          status: this.status || 0,
          id: query == 'default' ? this.value : 0,
          transfer_list: this.transfer,
          base_id: this.baseid,
          drill_well_id: this.wellid,
        }

        let res = await itemList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
    clearSelected() {
      this.selected = ''
    },
  },
}
</script>